export default __webpack_public_path__ + "static/media/Tools-P2-CIFOR.46d6e4f8.jpg";